/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
//import { useSelector } from "react-redux";
import useForm from "../../hooks/useForm";

// Redux Store
import Form from "../Form";
import Modal, { ModalHeader } from "../Modal";
import { isObject } from "lodash-es";
import systemAlert from "../../utils/systemAlert";
import { viewLoading } from "../../utils/loading";
//import Profile from "../Profile";
import { dateToViewFormatWithDayNameWithTime, getDay } from "../../utils/date";
import NoticeIcon from "../../assets/images/icon/notice-icon.svg";
import Icon from "../Icon";
import { get } from "lodash";
import { CARE_COMPANY_MEMO_COMPLETED } from "../../constants/CARE_COMPANY";
import { addCompanyManagerSchedule, modifyCompanyManagerSchedule } from "../../apis/admin/companies";
import { isEmpty } from "../../utils/lodashExtend";


const CareCompanyScheduleWrite = ({
  company,
  managerCompany,
  schedule,
  setSchedule,
  toggle,
  setToggle,
  formType,
}) => {
  const [mode, setMode] = useState('create');
  const [buttons, setButtons] = useState([]);
  /*
  const { employees } = useSelector((store) => ({
    employees: store.Data.employees,
  }));
  */

  const reset = () => {
    setMode('create');
    resetForm();
  };

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setSchedule(null);
    setToggle(false);
    reset();
  };

  const [fields, setFields] = useState([]);

  const submit = (
    _form
  ) => {

    const form = {
      ..._form,
      date: _form.date[0],
    };

    if (form?.idx) {
      delete form.idx;
    }

    if (mode === "create") {
      systemAlert(`"${company.name}" 일정을 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              viewLoading(true);
              addCompanyManagerSchedule(managerCompany.companyIdx, company.companyIdx, form)
                .then((res) => {
                  close();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`"${company.name}" 일정을 수정 하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {

              viewLoading(true);
              modifyCompanyManagerSchedule(managerCompany.companyIdx, company.companyIdx, schedule.idx, form)
                .then((res) => {
                  close();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    }

  };

  const {
    form,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    resetForm,
  } = useForm({
    date: getDay(0),
    title: "",
    content: "",
    fileIdxes: [],
    completed: "0",
  },
    submit,
    null,
    fields
  );

  useEffect(() => {
    !isEmpty(form) && setFields([
      [
        {
          isHide: mode === 'create',
          title: "작성일",
          type: 'component',
          component: () => {
            return <>{dateToViewFormatWithDayNameWithTime(get(schedule, 'createdTime'))}</>;
          }
        },
        /*
        {
          isHide: mode === 'create',
          title: "작성자",
          type: 'component',
          component: () => {
            const writer = employees.find(d => d.idx === get(schedule, 'writerEmployeeIdx'))
            return <><Profile data={writer}></Profile></>
          }
        },
        */
      ],
      {
        title: "작업일",
        key: "date",
        type: "datepicker",
        required: true,
        width: '350px'
      },
      {
        title: "제목",
        key: "title",
        type: "input",
        required: true,
      },
      {
        title: "내용",
        key: "content",
        type: "editor",
        // required: true,
      },
      {
        title: "첨부파일",
        key: "fileIdxes",
        type: "dropzone",
        required: false,
      },
      {
        isHide: mode === 'view',
        title: "처리여부",
        key: "completed",
        type: "select",
        className: "zIndex-0",
        defaultValue: !isEmpty(schedule) && isObject(schedule) ? String(get(schedule, 'completed')) : form.completed,
        options: {
          list: CARE_COMPANY_MEMO_COMPLETED,
        },
      },
      {
        isHide: mode !== 'view',
        title: "처리여부",
        key: "completed",
        onValue: (value) => {
          const data = CARE_COMPANY_MEMO_COMPLETED.find((e) => e.value === String(value));
          if (data) {
            return data.label;
          } else {
            return '';
          }
        }
      },
    ]);
  }, [form]);


  useEffect(() => {
    if (!isEmpty(schedule) && isObject(schedule)) {
      setForm({
        idx: schedule.idx,
        date: schedule.date,
        title: schedule.title,
        content: schedule.content,
        fileIdxes: schedule.uploadFiles,
        completed: schedule.completed,
      });
    }

    setMode(formType);
    if (formType === "create" || formType === "modify") {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close
        },
        {
          label: formType === "create" ? "작성완료" : "수정",
          onClick: handleSubmit,
        },
      ]);
    } else if (formType === "view") {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close,
        },
      ]);
    }
  }, [schedule, formType]);

  return (
    <Modal
      isOpen={toggle}
      close={close}
    >
      <div className="client-write" >
        <ModalHeader>
          <Icon src={NoticeIcon} />&nbsp;
          "{company.name}" 메모 {mode === 'create' && "작성"}
        </ModalHeader>
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          // submit={handleSubmit}
          // cancelText={'닫기'}
          // cancel={close}
          errors={errors}
          buttons={buttons}
        />
      </div>
    </Modal>
  );
};


export default CareCompanyScheduleWrite;
